var map = {
	"./Abhinav/index.css": [
		83095,
		3095
	],
	"./Agrasen/index.css": [
		73515,
		3515
	],
	"./Bhagini/index.css": [
		86856,
		6856
	],
	"./Deogiri/index.css": [
		28111,
		8111
	],
	"./JCOM/index.css": [
		72489,
		2489
	],
	"./MOGAVEERA/index.css": [
		30175,
		175
	],
	"./Mahesh/index.css": [
		46358,
		6358
	],
	"./NCBM/index.css": [
		76838,
		6838
	],
	"./Noble/index.css": [
		3920,
		3920
	],
	"./RSSB/index.css": [
		49938,
		9938
	],
	"./Samta/index.css": [
		36172,
		6172
	],
	"./Satara/index.css": [
		29642,
		9642
	],
	"./Sawji/index.css": [
		87272,
		7272
	],
	"./Shriraksh/index.css": [
		27453,
		7453
	],
	"./Suvarna/index.css": [
		92056,
		2056
	],
	"./Ucob/index.css": [
		49359,
		9359
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65264;
module.exports = webpackAsyncContext;